import { GroupDescriptor, SortDescriptor } from '@progress/kendo-data-query'
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  GridFilterActionState,
  GridFilterState,
} from 'store/grid'

interface ActionState {
  skip: number
  take: number
  sort: SortDescriptor[]
  group: GroupDescriptor[]
  filterName: string
  filter: {
    logic: 'or' | 'and'
    filters: (CompositeFilterDescriptor | FilterDescriptor)[]
  }
  total: number
  pageIndex: number
  pageSize: number
}

export const mergeActionState = (
  actionState: GridFilterActionState,
  initialState: GridFilterState
): ActionState => ({
  ...initialState,
  skip: actionState?.skip ?? initialState.skip,
  take: actionState?.take ?? initialState.take,
  sort: actionState?.sort ?? initialState.sort,
  group: actionState?.group ?? initialState.group,
  filterName: actionState?.filterName ?? initialState.filterName,
  filter: {
    logic: actionState?.filter?.logic ?? initialState.filter.logic,
    filters: actionState?.filter?.filters ?? initialState.filter.filters,
  },
  total: actionState?.total ?? initialState.total,
  pageIndex: actionState?.pageIndex ?? initialState.pageIndex,
  pageSize: actionState?.pageSize ?? initialState.pageSize,
})
